import React from "react";

export default function Header() {
  return (
    <header>
      <h1>Find Your Perfect mAb Solution</h1>
      <p className="typography__caption">
          Do you want to tackle the challenges of mAb discovery? This tool will help you identify the right solution for every workflow step!
      </p>
    </header>
  );
}
